var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEyeLs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEyeLS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-15.000000, -11.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,11 C30.894395,11 34.879462,13.2989739 37.8200368,17.0376184 C38.0599877,17.3435484 38.0599877,17.7709506 37.8200368,18.0768806 C34.879462,21.8110261 30.894395,24.11 26.5,24.11 C22.105605,24.11 18.120538,21.8110261 15.1799632,18.0723816 C14.9400123,17.7664516 14.9400123,17.3390494 15.1799632,17.0331194 C18.120538,13.2989739 22.105605,11 26.5,11 Z M26.4450881,22.0308645 C28.7671876,21.8869039 30.6530413,20.0764909 30.8030008,17.8472835 C30.9802256,15.1382077 28.6535819,12.9090003 25.8361619,13.0791355 C23.5095182,13.2187336 21.6236645,15.0291467 21.4782492,17.2627165 C21.3010244,19.9717923 23.6276681,22.2009997 26.4450881,22.0308645 Z M26.3019033,19.9650786 C24.7845247,20.0566834 23.530643,18.8570968 23.6305901,17.4001443 C23.7078219,16.1961955 24.725465,15.2234398 25.9793467,15.1449214 C27.4967253,15.0533166 28.750607,16.2529032 28.6506599,17.7098557 C28.568885,18.9181666 27.5512419,19.8909223 26.3019033,19.9650786 Z",
    id: "icEyeLS"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeLs);
export default __webpack_public_path__ + "static/media/icEyeLS.af1d8d75afbe74002b98ac86ed5e3991.svg";
export { ForwardRef as ReactComponent };